/**
 * ConditionField - thin wrapper around the shared ConditionBuilder
 * used throughout the action modal (`condition`, each blocker's
 * `predicate`, each override's `when`, authorization `condition`).
 */

import { Label } from '@/shared/components/ui/label'
import { ConditionBuilder } from '@/admin/components/condition-builder'
import type {
  AvailableRef,
  PredicateNode,
} from '@/admin/components/condition-builder/types'

interface ConditionFieldProps {
  label: string
  hint?: string
  value: PredicateNode | null
  onChange: (next: PredicateNode | null) => void
  refsLoading: boolean
  refs: AvailableRef[]
  byRef: (ref: string) => AvailableRef | undefined
}

export function ConditionField({
  label,
  hint,
  value,
  onChange,
  refsLoading,
  refs,
  byRef,
}: ConditionFieldProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <Label className="text-[11px] uppercase tracking-[0.1em] text-[var(--ink-3)]">
        {label}
      </Label>
      {hint && <p className="text-[10px] text-[var(--ink-3)]">{hint}</p>}
      {refsLoading ? (
        <div className="rounded-[6px] border-[0.5px] border-[var(--rule)] bg-[var(--bg)] px-3 py-4 text-center text-[12px] text-[var(--ink-3)]">
          Loading fields…
        </div>
      ) : (
        <ConditionBuilder
          value={value}
          onChange={onChange}
          availableRefs={refs}
          byRef={byRef}
        />
      )}
    </div>
  )
}

